module.exports = __webpack_public_path__ + "static/img/11.27db2ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/11.png
// module id = aMeC
// module chunks = 0